import styled, { css } from "styled-components";
import { DhlText } from "@dhl-official/react-library";
import { breakpoints } from "root/libs/ui-styleguide/src";
import {
  Headline,
  GridContainer,
  biDimemsionalCell,
} from "root/libs/ui-components/src";

export const StyledHeadlineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin: var(--gaq-size-space-35px) var(--dui-size-space-10x) 0
    var(--dui-size-space-10x);
  align-items: flex-start;

  @media screen and (min-width: ${breakpoints.phablet}) {
    align-items: flex-start;
    margin: var(--dui-size-space-50x) 0 var(--dui-size-space-20x);
    flex-wrap: unset;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-bottom: 0;
    margin-top: var(--gaq-size-space-30px);
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    margin-top: var(--gaq-size-space-35px);
  }

  @media print {
    align-items: center;
  }
`;

export const StyledDivForPDFPrinting = styled.div`
  display: none;

  @media print {
    display: block;
    break-after: page;
  }
`;

export const OfferLaneWrapper = styled.section`
  background-color: #fbfbfb;
  padding: var(--dui-size-space-5x) 0
    ${(props) => (props.isExpanded ? 0 : "var(--dui-size-space-20x)")};

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding-left: var(--gaq-size-space-30px);
    padding-right: var(--gaq-size-space-30px);
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    padding-left: 0;
    padding-right: 0;
  }

  @media print {
    width: 80%;
    max-width: 80%;
    margin: 0 10%;
    background-color: transparent;
    padding: 0;
  }
`;

export const OffersSectionWrapper = styled.section`
  ${({ stepperEnabled }) =>
    stepperEnabled &&
    `
      @media screen and (min-width: ${breakpoints.desktop}) {
        margin: 0 var(--gaq-size-space-30px);
      }
    `}
`;

export const StyledIconWrapper = styled.div`
  margin: 0 auto;
  display: inline-block;

  svg {
    color: var(--dui-color-red-500);
    width: var(--gaq-size-space-52px);
    height: var(--gaq-size-space-52px);
  }
`;

export const BackButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin: var(--gaq-size-space-35px) var(--dui-size-space-10x) 0
    var(--dui-size-space-10x);
  align-items: flex-start;
  ${({ stepperEnabled }) =>
    stepperEnabled &&
    `
      margin-left: var(--dui-size-space-10x);

      @media screen and (min-width: ${breakpoints.tablet}) {
        margin-left: var(--gaq-size-space-30px) !important;
      }
    `}
`;

export const CustomBackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: var(--dui-colors-action-background-secondary-default);
  color: var(--dui-colors-action-foreground-secondary-default);
  border: var(--dui-size-space-1) solid
    var(--dui-colors-action-foreground-secondary-default);
  padding: 10px 16px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s ease;

  font-weight: var(--dui-font-weight-bold);

  &:focus-visible {
    outline: var(--dui-size-space-1x) solid
      var(--dui-colors-action-background-primary-default);
    outline-offset: var(--dui-size-space-1x);
    z-index: 1;
  }

  &:hover {
    border-color: var(--dui-colors-action-foreground-secondary-hover);
    color: var(--dui-colors-action-foreground-secondary-hover);
    svg {
      color: var(--dui-colors-action-foreground-secondary-hover);
    }
  }

  svg {
    width: 16px;
    height: 16px;
    color: var(--dui-colors-action-foreground-secondary-default);
    transition: color 0.2s ease;
  }
`;

export const OfferFilterWrapper = styled(GridContainer)`
  @supports (display: grid) {
    @media screen and (min-width: ${breakpoints.tablet}) {
      grid-template-columns: repeat(12, 1fr);
    }
    @media screen and (min-width: ${breakpoints.desktop}) {
      ${({ stepperEnabled }) =>
        stepperEnabled
          ? `grid-template-columns: repeat(12, 67px);`
          : `grid-template-columns: repeat(12, 73px);`}
    }
  }

  @media screen and (min-width: ${breakpoints.phablet}) {
    padding-top: var(--dui-size-space-10x);
  }

  /* Only for IE11 */
  @media all and (-ms-high-contrast: none) {
    max-width: 100rem;
  }

  /* Only for EDGE */
  /* stylelint-disable selector-type-no-unknown */
  _:-ms-lang(x),
  _:-webkit-full-screen,
  & {
    max-width: 100rem;
  }
  /* stylelint-enable selector-type-no-unknown */
`;

export const ieShippingDateWrapper = css`
  /* Only for IE11 */
  @media all and (-ms-high-contrast: none) {
    width: 40%;
  }

  /* Only for EDGE */
  /* stylelint-disable selector-type-no-unknown */
  _:-ms-lang(x),
  _:-webkit-full-screen,
  & {
    width: 40%;
  }
  /* stylelint-enable selector-type-no-unknown */
`;

export const ShippingDateWrapper = styled.div`
  ${biDimemsionalCell}
  ${ieShippingDateWrapper}


  @media screen and (min-width: ${breakpoints.tablet}) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    grid-column-end: span 4;
    grid-column-start: 1;
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    display: block;
    flex-wrap: inherit;
    justify-content: inherit;
    align-items: inherit;
    grid-column: 2 / span 3;
    ${({ isLoading }) =>
      isLoading &&
      `
        margin-left: var(--dui-size-space-16x);
      `}
  }

  @media print {
    display: none;
  }
`;

export const ShippingDateSelectWrapper = styled.div`
  width: 100%;

  .date-picker {
    div {
      box-sizing: content-box;

      button {
        line-height: normal;
      }
    }

    > div[role="dialog"] {
      z-index: 4;
    }
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    width: auto;
    min-width: 200px;
    margin-bottom: var(--dui-size-space-10x);
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    margin-bottom: var(--gaq-size-space-25px);
  }
`;

export const StyledHeadline = styled(Headline)`
  margin: 0;
`;

export const StyledText = styled(DhlText)`
  display: block;

  & > *:is(p, span) {
    margin-top: var(--gaq-size-space-5px);

    @media screen and (min-width: ${breakpoints.tablet}) {
      margin-top: 0;
    }

    @media screen and (min-width: ${breakpoints.desktop}) {
      margin-top: var(--gaq-size-space-5px);
    }
  }

  @media print {
    display: none;
  }
`;

export const OfferWrapper = styled.div`
  margin-bottom: calc(var(--dui-size-space-5x) * 5);
  padding: 0 0;

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-bottom: 45px;
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    margin-bottom: var(--gaq-size-space-35px);
    padding: 0 0;
    max-width: 100rem;
  }
`;

export const Disclaimer = styled.div`
  margin-top: var(--gaq-size-space-26px);

  dhl-text {
    display: block;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    > * {
      max-width: 53%;
      margin: 0 auto;
      text-align: center;
    }
  }

  @media print {
    margin-top: 0;
  }
`;

export const VisitLaterActionsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: var(--dui-size-space-32x) var(--dui-size-space-5x) 0;
  justify-content: center;

  > div {
    width: 100%;
    max-width: 220px;
    margin: 0 var(--dui-size-space-5x) var(--dui-size-space-5x)
      var(--dui-size-space-5x);

    > * {
      width: 100%;
      white-space: nowrap;
    }
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    > div:first-child {
      margin: 0 0 var(--dui-size-space-5x) 0;
    }

    > div:last-child {
      margin: 0 0 var(--dui-size-space-5x) 0;
    }
  }

  @media print {
    display: none;
  }

  dhl-button > .styled.md.primary:is(button, a):hover {
    color: var(--dui-color-white-500) !important;
  }
`;

export const PrintDisclaimerWrapper = styled.div`
  display: none;
  text-align: center;
  width: 100%;
  margin-top: 40px;

  @media print {
    display: block;
    margin-top: 0;
  }
`;

export const SaveShipmentButtonWrapper = styled.div`
  ${biDimemsionalCell}
  padding-bottom: 30px;

  > button {
    width: 100%;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding-bottom: 0;
    grid-column-end: span 4; // was 3
    grid-column-start: 10;
    text-align: end;
    padding-top: 5px;

    > button {
      width: auto;
    }
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    grid-column-start: 8; // was 9
  }

  @media print {
    display: none;
  }
`;
